export const GET_ALL_SLABS = "GET_ALL_SLABS"
export const STORED_SELECTED_SLAB = "STORED_SELECTED_SLAB"
export const GET_ALL_FORM_RES = "GET_ALL_FORM_RES"
 